<ion-grid class="shadow-box ion-no-padding" [class]="state">
  <ion-row
    class="ion-align-items-center ion-justify-content-center ion-no-padding ion-no-margin"
  >
    <ion-col size="2" >
      <icon-info-modal *ngIf="!iconInformation" class="centered-icon"></icon-info-modal>
      <icon-check-modal *ngIf="iconInformation" class="centered-icon"></icon-check-modal>
    </ion-col>
    <ion-col size="8" >
      <ion-text>
        <h3>{{ message[state].title }}</h3>
        <p>{{ message[state].subtitle }}</p>
      </ion-text>
    </ion-col>
    <ion-col (click)="closeMessage()" (keypress)="true" size="2" >
      <icon-close-modal class="centered-icon"></icon-close-modal>
    </ion-col> </ion-row>
  </ion-grid>
